import React from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    ScatterController,
} from 'chart.js';

// Register required Chart.js components
ChartJS.register(
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
    ScatterController
);

const PerformancePlot = ({ chartDataJson }) => {

    if (!chartDataJson || !chartDataJson.geometries_data) {
        return <div>Loading or no data available...</div>;
    }

    const { output_var, loaded_boundary, geometries_data } = chartDataJson;

    // Prepare datasets: 2 per geometry (prediction line + actual scatter)
    const datasets = geometries_data.flatMap(({ geometry_index, predictions, actuals }) => [
        {
            label: `Prediction Testing Geo ${geometry_index}`,
            data: predictions,
            borderColor: `rgba(54, 162, 235, 0.7)`,
            backgroundColor: `rgba(54, 162, 235, 0.3)`,
            fill: false,
            showLine: true,
            pointRadius: 0,
            borderWidth: 2,
            tension: 0.3,
            yAxisID: 'y',
            type: 'line',
        },
        {
            label: `Actual Testing Geo ${geometry_index}`,
            data: actuals,
            borderColor: `rgba(255, 99, 132, 0.9)`,
            backgroundColor: `rgba(255, 99, 132, 0.9)`,
            showLine: false,
            pointRadius: 5,
            yAxisID: 'y',
            type: 'scatter',
        }
    ]);

    const data = {
        datasets,
    };

    const options = {
        responsive: true,
        interaction: {
            mode: 'nearest',
            intersect: false,
        },
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 12,
                    padding: 10,
                },
            },
            title: {
                display: true,
                text: `${output_var} vs ${loaded_boundary} (Testing Data)`,
                font: {
                    size: 18,
                },
            },
            tooltip: {
                mode: 'nearest',
                intersect: false,
            },
        },
        scales: {
            x: {
                type: 'linear',
                title: {
                    display: true,
                    text: loaded_boundary,
                },
            },
            y: {
                title: {
                    display: true,
                    text: output_var,
                },
                beginAtZero: false,
            },
        },
    };

    return <Line data={data} options={options} />;
};

export default PerformancePlot;
